import * as yup from 'yup';
export var validationSchema = yup.object().shape({
    searchValue: yup.string(),
    searchType: yup.string().required(),
});
